import { PullAndSendFormFields } from './PullAndSendForm';
import { analysisRequestColumnBuilders } from '../UploadAnalayzeForm';
import { WorkbookColumnBuilders } from '../../@types';
import { PULL_SEND_REQUEST_TYPES } from '../constants';

/**
 * Column builders for Pull & Send Request
 *
 * For Rating Analysis: Uses analysis columns + pull data fields (From Date, To Date, Pull Data)
 * For other types: The backend may handle pull data differently - TBD based on testing
 */

export const pullAndSendColumnBuilders: WorkbookColumnBuilders<PullAndSendFormFields> =
  {
    // Pull Data columns (used for all types when pulling data)
    'From Date': (formFields) => formFields.dateRange?.startDate || '',
    'To Date': (formFields) => formFields.dateRange?.endDate || '',
    'Pull Data': () => 'Yes',

    // For Rating Analysis, include all analysis columns
    ...analysisRequestColumnBuilders,
  };
